import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { toUpper } from "ramda";

import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  badge: {
    background: "rgba(125, 218, 252, 0.5)",
    borderRadius: 4,
    padding: "8px 12px",
    gap: 10,
    width: "auto",
    height: 32,
  },

  icon: {
    color: theme.palette.primary.main,
    fontWeight: 400,
  },

  mediaType: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: "16px",
    color: theme.palette.primary.main,
  },
}));

const ContentGroupBadge = ({ mediaType }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      justify="center"
      alignItems="center"
      className={classes.badge}
    >
      <div className={classes.icon}>
        <Icon fontSize="small" className={`bbico-${mediaType}`} />
      </div>
      <Typography className={classes.mediaType}>
        {toUpper(mediaType)}
      </Typography>
    </Grid>
  );
};

export default ContentGroupBadge;
